import { EVENTS } from '../config/constants';

const DISABLE_COLLAPSE_BREAKPOINT = 540;

export default function () {
  Object.values(EVENTS.BS.COLLAPSE).forEach(watchEvent);
}

function watchEvent(eventName) {
  window.addEventListener(eventName, handleFooterCollapsible);
}

function handleFooterCollapsible(ev) {
  const isFooterChild = ev.target.closest('.js-footer');
  const { innerWidth: windowWidth } = window;

  if (!isFooterChild || windowWidth < DISABLE_COLLAPSE_BREAKPOINT) {
    return;
  }

  ev.preventDefault();
}
